module.exports = __webpack_public_path__ + "img/sign-34.8b15128d.jpg";